import {validationMessages} from "../models/validators.model";

export function getErrorMessage(control: any): string {
	const error: string = Object.keys(control['errors'])[0];
	return getMessageLabel(error)
}

export function getDateErrorMessage(control: any): string {
	const errors: Array<string> = Object.keys(control['errors']);
	if (errors.find(err => err == 'matDatepickerParse')) {
		return getMessageLabel('matDatepickerParse');
	}
	const error: string = Object.keys(control['errors'])[0];
	return getMessageLabel(error)
}

function getMessageLabel(messageKey: string): string {
	const message = validationMessages[messageKey];
	if (message) {
		return message;
	} else {
		return messageKey;
	}
}
